import { styled } from '@mui/material/styles';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import { ImgBox } from 'views/rebranded-module/common/components/UI/ImgBox';
import { Box } from '@mui/material';

const StyledBox = styled(Box)(({ theme }) => ({
  padding: theme.spacing(3),
  backgroundColor: theme.palette.common.white,
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(2),
  },
}));

export const StyledCarousel = styled(Carousel)(({ theme }) => ({
  '& .react-multi-carousel-track': {
    paddingBottom: theme.spacing(3),
    [theme.breakpoints.down('md')]: {
      paddingBottom: theme.spacing(3),
    },
  },
  '& .react-multiple-carousel__arrow': {
    '&.react-multiple-carousel__arrow--right': {
      right: 0,
    },
    '&.react-multiple-carousel__arrow--left': {
      left: 0,
    },
  },
  '& .react-multi-carousel-item': {
    '& .MRSCarouselItem': {
      margin: theme.spacing(0, 0.875),
    },
    '&:first-child': {
      '& .MRSCarouselItem': {
        margin: theme.spacing(0, 1.75, 0, 0),
      },
    },
    '&:last-child': {
      '& .MRSCarouselItem': {
        margin: theme.spacing(0, 0, 0, 1.75),
      },
    },
    '&:only-child': {
      '& .MRSCarouselItem': {
        margin: theme.spacing(0, 2.5, 0, 0),
      },
    },
  },
  '& .react-multi-carousel-dot-list ': {
    '& .react-multi-carousel-dot': {
      width: '100%',
      '& button': {
        width: '100%',
        height: 3,
        border: 0,
        borderRadius: theme.spacing(0.5),
        backgroundColor: theme.palette.grey.A000,
      },
      '&.react-multi-carousel-dot--active': {
        '& button': {
          backgroundColor: theme.palette.grey[300],
        },
      },
    },
  },
}));

export const StyledImgBox = styled(ImgBox)(({ theme }) => ({
  '&.IBimgbox': {
    [theme.breakpoints.down('md')]: {
      height: theme.spacing(18),
    },
  },
}));

export default StyledBox;
